import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HotlineClientCreateCompletePage } from '@/feature/hotline/client/create/complete/page/HotlineClientCreateCompletePage';
/**
 * 匿名ホットライン投稿 完了
 * @description api データ取得を伴わないアクセス制限等を行う
 */
export const HotlineClientCreateComplete = () => (_jsx(HotlineClientCreateCompletePage, {}));
